module.exports = __webpack_public_path__ + "static/img/navw.c8c986d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/navw.png
// module id = 1f7W
// module chunks = 0